import apis from '../../api/apis'
import router from '../../router'

const account = {
  state: {
    token: '',
    userInfo: {}
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    setUserInfo(state, info) {
      state.userInfo = info
    },
    logout(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.clear()
      router.replace('/login')
    }
  },
  actions: {
    getUserInfo({state}) {
      let data = {
        id: localStorage.getItem('userId')
      }
      apis.methods.getUserInfo(
        data,
        res => {
          if (res.data.code == 0) {
            state.userInfo = res.data.data
          } else {
            this.$toast(res.data.message)
          }
        },
        err => {
          console.log(err)
        }
      )
    }
  }
}
export default account



// WEBPACK FOOTER //
// ./src/store/modules/account.js